import { api } from "@/lib/api";

// Lightweight, client-side share tracking for creators. Records the creator's own "I shared this"
// taps in localStorage (works today, per-device) AND fires best-effort backend share-events so real
// cross-user opens/adds accrue the moment the mobile analytics endpoint ships (see HANDOFF_share_analytics.md).
const KEY = "bloq_share_stats";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}
function write(obj) {
  try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch { /* ignore quota */ }
}

// Records a local "you shared this" tap + fires a best-effort backend "copy" event.
export function recordShare(packId) {
  if (!packId) return;
  const s = read();
  const e = s[packId] || { shares: 0 };
  e.shares = (e.shares || 0) + 1;
  e.lastSharedAt = new Date().toISOString();
  s[packId] = e;
  write(s);
  api.stickerShareEvent(packId, "copy");
}

// Fire-and-forget backend event for a funnel step we can attribute (open / add).
export function trackShareEvent(packId, type) {
  if (!packId || !type) return;
  api.stickerShareEvent(packId, type);
}

export function localShares(packId) {
  return read()[packId]?.shares || 0;
}
